export default __webpack_public_path__ + "static/media/white-logo.caaaf976.png";